import { Entity } from "../Entity";
import { selection } from "../../editions/selection/Selection";
import { TextService } from "./TextService";

export class Text extends Entity {

    constructor({
        id = null,
        description,
        container,
        graphicItem
    }) {
        super({
            id,
            container,
            graphicItems: [graphicItem],
            type: 'text',
            enableCacheAsBitmap: false
        });

        if ((this.description = description)) {
            this.originalLabel = this.label;
            this.label = this.description.label;
        }
    }

    set label(value) {
        this.graphicItems[0].text = value;

        if (this.isSelected) {
            this.drawSelectedArea();
            selection.update();
        }
    }

    get label() {
        return this.graphicItems[0].text
    }

    set fontSize(value) {
        this.graphicItems[0].style.fontSize = parseInt(value);

        if (this.isSelected) {
            this.drawSelectedArea();
            selection.update();
        }
    }

    get fontSize() {
        return this.graphicItems[0].style.fontSize
    }

    clone() {
        return TextService.createFromProps(this.getProps())
    }

    getProps() {
        const { label, fontSize, description, originalLabel } = this;
        return {
            ...super.getProps(),
            label: description ? originalLabel : label,
            fontSize,
            descriptionId: description ? description.id : null
        }
    }

    updateFromProps(rowProps, bindProps = null) {
        super.updateFromProps(
            rowProps,
            bindProps,
            props => TextService.createFromProps(props),
            newEntity => {
                this.label = newEntity.label;
                this.fontSize = newEntity.fontSize;
            }
        )
    }
}